import * as React from 'react';

import { IconButton, Snackbar } from '@mui/material';

import MuiAlert, { AlertProps } from '@mui/material/Alert';

import CloseIcon from '@mui/icons-material/Close';

export interface IToast {
    show?: boolean;
    vertical?: 'top' | 'bottom';
    horizontal?: 'left' | 'center' | 'right';
    severity?: 'success' | 'info' | 'warning' | 'error';
    message?: string;
    sticky?: boolean;
    onClose?: any;
    autoHideDuration?: number;
}

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant='filled' {...props} />;
});

export const Toast: React.FC<IToast> = ({
    show,
    vertical = 'top',
    horizontal = 'center',
    severity = 'success',
    message,
    sticky = true,
    onClose,
    autoHideDuration = 2000,
}) => {
    const [open, setOpen] = React.useState(false);

    React.useEffect(() => {
        setOpen(true);
    }, []);

    const handleClose = (event: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpen(false);
        onClose(false);
    };

    const action = (
        <React.Fragment>
            <IconButton size='small' aria-label='close' color='inherit' onClick={handleClose}>
                <CloseIcon fontSize='small' />
            </IconButton>
        </React.Fragment>
    );

    if (!show) {
        return null;
    }

    return (
        <Snackbar
            anchorOrigin={{ vertical, horizontal }}
            open={open}
            autoHideDuration={autoHideDuration}
            onClose={handleClose}
            action={action}
        >
            <Alert
                severity={severity}
                onClose={handleClose}
                sx={{ width: '100%', boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.03)' }}
            >
                {message}
            </Alert>
        </Snackbar>
    );
};
